import { Message } from "../constants/types";
import { Steps } from "../constants/ui";

export const getSpotlightMessagesForStep = (
    step: Omit<Steps, "PULSE_CARD">,
    messages: Message
) => {
    switch (step) {
        case Steps.CREATE_FIRST_STORY:
            return {
                heading: messages.spotlightInitialCreateButtonHeading,
                description: messages.spotlightInitialCreateButtonDescription
            };
        case Steps.SELECT_ISSUE_TYPE:
            return {
                heading: messages.spotlightSelectIssueHeading,
                description: messages.spotlightSelectIssueDescription
            };
        case Steps.ADD_SUMMARY:
            return {
                heading: messages.spotlightSummaryHeading,
                description: messages.spotlightSummaryDescription
            };
        case Steps.ADD_DESCRIPTION:
            return {
                heading: messages.spotlightAddDescriptionHeading,
                description: messages.spotlightAddDescriptionDescription
            };
        case Steps.SELECT_PRIORITY:
            return {
                heading: messages.spotlightSelectPriorityHeading,
                description: messages.spotlightSelectPriorityDescription
            };
        case Steps.SELECT_EPIC_LINK:
            return {
                heading: messages.spotlightSelectEpicLinkHeading,
                description: messages.spotlightSelectEpicLinkDescription
            };
        case Steps.MOVE_ISSUE:
            return {
                heading: messages.spotlightMoveIssueHeading,
                description: messages.spotlightMoveIssueDescription
            };
        default:
            return {
                heading: "",
                description: ""
            };
    }
};
